import type { ReactNode } from 'react';

export const symbol_chess_pawn: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M220-80q-24.75 0-42.37-17.63Q160-115.25 160-140v-99q0-14 7-27t18-21q85-65 120.5-129.5T355-530h-82q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h75q-20-23-31.5-52.49Q305-671.97 305-705q0-72.92 51.04-123.96Q407.08-880 480-880q72 0 123.5 51.04T655-705q0 33.03-11.5 62.51Q632-613 612-590h75q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-82q14 49 49.5 113.5T775-287q11.36 8.87 18.18 21.43Q800-253 800-239v99q0 24.75-17.62 42.37Q764.75-80 740-80H220Zm0-60h520v-97q-93-73-138-155.5T543-530H417q-14 55-59 137.5T220-237v97Zm259.79-450q48.21 0 81.71-33.29 33.5-33.29 33.5-81.5t-33.29-81.71q-33.29-33.5-81.5-33.5t-81.71 33.29q-33.5 33.29-33.5 81.5t33.29 81.71q33.29 33.5 81.5 33.5Zm.21-115Zm0 565Z"
		/>
	</svg>
);
